import http from "@/utils/http";

export default {
  // uploadUrl: "http://qw.nvc-lighting.com.cn:8089/file/view/",
  // upload: "http://qw.nvc-lighting.com.cn:8089",
  // upload: "http://172.20.10.4:8082",
  upload: "https://qw.nvc-lighting.com.cn:8082",
  uploadUrl:'https://qw.nvc-lighting.com.cn:8082/file/view/',

  // 用户信息
  getUserInfo: data => http.post(`/gzhApi/user/queryUserInfo`, data),

  ////  首页管理
  //  首页下拉框数据列表
  homeSeleteDataList: () => http.get(`/gzhApi/home/page/areaList`),
  //  搜索 数据
  hoemSearchDataList: data => http.post(`/gzhApi/home/page/pageList`, data),
  // 新增 或 修改
  homeAddAndEdit: data => http.post(`/gzhApi/home/page/saveOrUpdate`, data),
  homeAdd: data => http.post(`/gzhApi/home/page/save`, data),
  homeEdit: data => http.post(`/gzhApi/home/page/update`, data),
  // 删除
  homeDeleteOnlyData: data => http.post(`/gzhApi/home/page/delete/`, data),
  // 编辑
  homeEditData: data => http.get(`/gzhApi/home/page/${data}`),
  //变更人
  homeChangePersonList: () => http.post(`/gzhApi/user/queryPage`),
  // 根据首页区域进行分组列表
  homeAreaList: () => http.get(`/gzhApi/home/page/list`),

  ////  直播管理
  // 搜索数据
  liveSearchDataList: data => http.post(`/gzhApi/live/details/list`, data),
  // 新增 或修改 直播详情
  liveAddAndEdit: data => http.post(`/gzhApi/live/details/saveOrUpdate`, data),
  // 删除直播详情
  liveDeleteOnlyData: data => http.post(`/gzhApi/live/details/delete`, data),
  // id查询详情
  liveIdQueryDetail: data => http.get(`/gzhApi/live/details/${data}`),
  // 添加或修改直播渠道
  liveAddAndEditChannel: data => http.post(`/gzhApi/live/channel/saveOrUpdate`, data),

  //渠道分页列表
  liveChannelPageList: data => http.post(`/gzhApi/live/channel/list`, data),
  //删除渠道
  liveDeteleChannel: data => http.delete(`/gzhApi/live/channel/${data}`),
  //直播详情列表
  liveStreamingDetailList: data => http.post(`/gzhApi/live/details/list`, data),
  //获取直播状态
  getLiveStatus: () => http.get(`/gzhApi/live/details/status`),

  //  //  产品管理

  //  添加或修改分类
  productAddAndEditCategory: data => http.post(`/gzhApi/product/categories/addOrUpdate`, data),
  // 根据id查询分类
  productQueryCategory: data => http.get(`/gzhApi/product/categories/${data}`),
  // 分类列表不分页
  productGetCategoryList: () => http.get(`/gzhApi/product/categories/list`),
  // 删除分类
  productDeleteCategory: data => http.delete(`/gzhApi/product/categories/${data}`),
  // 添加或修改产品
  productAddAndEditProduct: data => http.post(`/gzhApi/product/addOrUpdate`, data),
  // 根据id查询产品
  productQueryProduct: data => http.get(`/gzhApi/product/${data}`),
  //  产品列表
  productList: data => http.post(`/gzhApi/product/list`, data),
  // 删除产品
  productDeleteProduct: data => http.delete(`/gzhApi/product/${data}`),
  // 获取所有产品
  getAllProduct: () => http.get(`/gzhApi/product/listAll`),

  //  // 服务管理
  //  模块列表
  servicesGetModuleList: () => http.get(`/gzhApi/services/moduleList`),
  // 添加或修改服务
  servicesAddAndEditService: data => http.post(`/gzhApi/services/addOrUpdate`, data),
  // 根据id查询服务 编辑
  servicesEditService: data => http.get(`/gzhApi/services/${data}`),
  // 删除服务
  servicesDeleteService: data => http.post(`/gzhApi/services/delete`, data),
  //  服务列表
  serviceList: data => http.post(`/gzhApi/services/list`, data),

  // 移动端 服务 /services/listGroup
  dataList: () => http.get(`/gzhApi/services/listGroup`),

  // // 地图管理
  // 新增 或修改 地图
  mapAddAndEdit: data => http.post(`/gzhApi/map/addOrUpdate`, data),
  // 根据id 查地图
  mapEditMapData: data => http.get(`/gzhApi/map/${data}`),
  // id查询详情
  mapIdQueryDetail: data => http.get(`/gzhApi/map/${data}`),
  // 删除地图
  mapDeleteMap: data => http.post(`/gzhApi/map/delete`, data),
  //地图列表
  mapDataList: data => http.post(`/gzhApi/map/list`, data),
  // 根据经纬度获取 周围店铺 信息
  getStoreInfo: data => http.get(`/gzhApi/map/around?location=${data.location}&city=${data.city}`),

  // 根据经纬度获取 距离
  getDistanceInfo: data => http.get(`/gzhApi/map/distance?origins=${data.origins}&destination=${data.destination}`),
  // 根据区域获取店铺信息
  getSearchAroundStoreInfo: data => http.get(`/gzhApi/map/searchAround?location=${data.location}&district=${data.district}`),


  // //  故障自查管理
  // 添加或修改故障原因
  faultAddAndEdit: data => http.post(`/gzhApi/fault/addOrUpdate`, data),
  faultAdd: data => http.post(`/gzhApi/fault/add`, data),
  faultEdit: data => http.post(`/gzhApi/fault/update`, data),
  // 根据id查询
  faultEditMapData: data => http.get(`/gzhApi/fault/${data}`),
  // 故障删除
  faultDeleteMap: data => http.post(`/gzhApi/fault/delete`, data),
  //故障原因与可能原因对应的列表
  faultDataList: data => http.post(`/gzhApi/fault/list`, data),
  // 故障原因列表
  faultReasonList: data => http.post(`/gzhApi/fault/listAll`, data),
  // 可能原因列表
  faultReasonData: data => http.post(`/gzhApi/fault/listPossible`, data),

  // 根据当前行id查询关联的数据
  queryFaultData: data => http.get(`/gzhApi/fault/possible/${data}`),

  ////  安装管理
  // 新增或修改
  installationAddAndEdit: data => http.post(`/gzhApi/installation/addOrUpdate`, data),
  // 根据id查询
  installationEditMapData: data => http.get(`/gzhApi/installation/${data}`),
  // 安装删除
  installationDeleteMap: data => http.post(`/gzhApi/installation/delete`, data),
  //安装列表
  installationDataList: data => http.post(`/gzhApi/installation/list`, data),

  //// 发票管理
  // 添加发票渠道
  // invoicesChannelAdd: data => http.post(`/gzhApi/invoices/addChannel`, data),
  //发票 渠道列表
  invoicesChannelList: () => http.get(`/gzhApi/invoices/channelList`),
  // 添加或修改发票说明
  invoicesAddAndEdit: data => http.post(`/gzhApi/invoices/addOrUpdate`, data),
  invoicesAdd: data => http.post(`/gzhApi/invoices/add`, data),
  invoicesEdit: data => http.post(`/gzhApi/invoices/update`, data),
  // 根据id查询
  invoicesEditMapData: data => http.get(`/gzhApi/invoices/${data}`),
  // 安装删除
  invoicesDeleteMap: data => http.post(`/gzhApi/invoices/delete`, data),
  //安装列表
  invoicesDataList: data => http.post(`/gzhApi/invoices/list`, data),
  // 发票 列表 根据渠道分组
  invoicesList: () => http.get(`/gzhApi/invoices/list`),

  // 新增发票渠道
  addChannel: data => http.post(`/gzhApi/invoices/addChannel`, data),


  // 导入
  exportData: data =>
    http.post(`/gzhApi/excel/upload?type=${data.type}`, data.file, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    }),
  //导出
  downloadData: data =>
    http.post(
      `/gzhApi/excel/down?type=${data}`,
      {},
      {
        responseType: "blob"
      }
    ),
  
   // 意见反馈 列表
  queryFeedback: data => http.post(`/gzhApi/suggestions/list`, data),
   // 删除一条意见反馈
   deleteFeedback: data => http.delete(`/gzhApi/suggestions/${data}`),



   // 按照维修管理
   installMaintenancePageList: data => http.post(`/gzhApi/InstallMaintenance/pageList`, data),
   // 按照维修新增
   installMaintenanceAddOrUpdate: data => http.post(`/gzhApi/InstallMaintenance/addOrUpdate`, data),
   // 按照维修删除
   installMaintenanceDelete: data => http.post(`/gzhApi/InstallMaintenance/delete`, data),
};
